/*=========================================================================================
  File Name: index.js
  Namespace: lareas
  Description: Vuex Learning Areas Store
==========================================================================================*/
import {
  listLAreas,
  getLArea
} from '@/services/lareas.service.js'

const state = {
  lareaList: {},
  count: 0,
  next: null,
  previous: null,
  results: []
}

const getters = {
  getLAreas(state) {
    return Object.entries(state.lareaList).map(([key, value]) => {
      return {
        label: value.name.charAt(0).toUpperCase() + value.name.slice(1),
        value: key
      }
    })
  },
  getLAreasEntries(state) {
    return state.lareaList
  }
}

const mutations = {
  STORE_LAREA_LIST(state, lareas) {
    state.lareaList = {
      ...state.lareaList,
      ...lareas.entries.lareas
    }
    state.count = lareas.count
    state.next = lareas.next
    state.previous = lareas.previous
    state.results = [...state.results, ...lareas.results]
  },
  RESET_LAREAS(state) {
    state.lareaList = {}
  }
}

const actions = {
  async getLArea({
    commit
  }, lareaId) {
    const response = await getLArea({
      lareaId: lareaId
    })
    if (response) {
      commit('STORE_LAREA_LIST', response)
    }
    return response
  },
  async getAllLAreas({
    commit, rootState
  }, params = {}) {
    params.company = rootState.app.company
    params.page_size = 256
    const response = await listLAreas(params)
    if (response) {
      commit('STORE_LAREA_LIST', response)
    }
    return response
  },
  resetCurrentLAreas({
    commit
  }) {
    commit('RESET_LAREAS')
  }
}

export default {
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
}